import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function ResetSalesOrderApprovalDialog({
  open,
  submitting = false,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onCancel}
      disableEscapeKeyDown={submitting}
    >
      <DialogTitle>Reset Sales Order Approval?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will return the Sales Order to Agreement Pending. The client will need to approve the Sales Order again.
        </DialogContentText>
        <DialogContentText sx={{ mt: 2 }}>
          The previous approval will be retained in the order history, but it will no longer count as the active approval.
        </DialogContentText>
        <DialogContentText sx={{ mt: 2 }}>
          Existing payments, deposit invoices, proof approvals, artwork approvals, purchase orders, production records, and Sales Order contents will not be changed.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
        <Button
          color="warning"
          variant="contained"
          onClick={onConfirm}
          disabled={submitting}
        >
          {submitting ? "Resetting..." : "Reset Approval"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
